import { useEffect } from "react";
import { useDispatch, useSelector} from "react-redux";
import { addTopRatedMovies } from "../utils/movieSlice";
import { API_OPTIONS } from "../utils/constants";

const useTopRatedMovies =() =>{
    const dispatch =useDispatch();
    const topRatedMovies = useSelector(
        (store) => store.movies.topRatedMovies
    );
    const getTopRetedMovies = async () =>{
        const data = await fetch(
            "https://api.themoviedb.org/3/movie/top_rated?page=1", 
            API_OPTIONS
        );
        const topRatedMovies = await data.json(); 
       // console.log(popularMovies.results);
        dispatch(addTopRatedMovies(topRatedMovies.results));

    }
    useEffect(() =>{
        !topRatedMovies && getTopRetedMovies();
    },[])

}
export default useTopRatedMovies;